import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
  return {
    snackbarContent: {
      backgroundColor: theme.palette.primary.main,
    },
  };
});
